import React, { useEffect } from "react";
import "./Snackbar.css";

/**
 * Reusable Snackbar notification component.
 *
 * Props:
 *  - message  (string)  : Text to display
 *  - type     (string)  : "success" | "error" | "info" | "warning"
 *  - open     (bool)    : Whether the snackbar is visible
 *  - onClose  (func)    : Callback when the snackbar closes
 *  - duration (number)  : Auto-dismiss time in ms (default 4000, pass 0 to disable)
 */
function Snackbar({ message, type = "info", open, onClose, duration = 4000 }) {
  useEffect(() => {
    if (open && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [open, duration, onClose]);

  if (!open) return null;

  const icons = {
    success: "\u2713",
    error: "\u2717",
    warning: "\u26A0",
    info: "\u2139",
  };

  return (
    <div className={`snackbar snackbar--${type} snackbar--visible`}>
      <span className="snackbar__icon">{icons[type] || icons.info}</span>
      <span className="snackbar__message">{message}</span>
      <button className="snackbar__close" onClick={onClose} aria-label="Close">
        &times;
      </button>
    </div>
  );
}

export default Snackbar;
